export enum OrderStatusMarketplaceActionEnum {
    APPROVE_ORDER = 'approve_order',
    SET_DELIVERY_NUMBER = 'set_delivery_number',
    DECLINE_ORDER = 'decline_order',
}
